<template>
  <div class="usuarios-roles">
    <div class="content-header">
      <h1 class="content-header-title">Roles y Permisos</h1>
      <p class="content-header-subtitle">Gestiona los roles y permisos del sistema</p>
    </div>
    
    <!-- Estado de carga -->
    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="primary" label="Cargando roles..."></b-spinner>
      <p class="mt-2">Cargando roles...</p>
    </div>
    
    <!-- Error al cargar -->
    <div v-else-if="error" class="alert alert-danger">
      <h5>Error al cargar los roles</h5>
      <p>{{ error }}</p>
      <b-button variant="outline-primary" @click="cargarRoles">
        <feather-icon icon="RefreshCwIcon" size="14" class="mr-1" />
        Reintentar
      </b-button>
    </div>
    
    <!-- Tabla de roles -->
    <b-card v-else>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Lista de Roles</h5>
        <b-button variant="primary" @click="cargarRoles">
          <feather-icon icon="RefreshCwIcon" size="14" class="mr-1" />
          Actualizar
        </b-button>
      </div>
      
      <b-table 
        :items="roles" 
        :fields="rolesFields" 
        responsive 
        striped 
        hover
        :busy="loading"
        show-empty
        empty-text="No hay roles disponibles"
      >
        <template #cell(acciones)="data">
          <b-button-group size="sm">
            <b-button variant="outline-warning" @click="editarRol(data.item.idRol)">
              <feather-icon icon="EditIcon" size="14" />
            </b-button>
            <b-button variant="outline-danger" @click="eliminarRol(data.item.idRol)">
              <feather-icon icon="TrashIcon" size="14" />
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import rolService from '@/services/rolService'

export default {
  name: 'UsuariosRoles',
  data() {
    return {
      rolesFields: [
        { key: 'idRol', label: 'ID' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'acciones', label: 'Acciones' },
      ],
      roles: [],
      loading: false,
      error: null,
    }
  },
  async mounted() {
    await this.cargarRoles()
  },
  methods: {
    /**
     * Carga todos los roles desde la API
     */
    async cargarRoles() {
      this.loading = true
      this.error = null
      
      try {
        console.log('🔄 Cargando roles desde la API...')
        console.log('🔧 Configuración actual:', {
          baseURL: this.$http.defaults.baseURL,
          timeout: this.$http.defaults.timeout,
          headers: this.$http.defaults.headers
        })
        
        // Prueba directa de la API
        console.log('🧪 Probando conexión directa...')
        const testResponse = await this.$http.get('/roles')
        console.log('✅ Respuesta directa:', testResponse.data)
        
        const rolesData = await rolService.getAllRoles()
        this.roles = rolesData
        console.log('✅ Roles cargados exitosamente:', rolesData)
        
        this.$toast({
          component: { template: '<div>Roles cargados correctamente</div>' },
          props: { variant: 'success' },
        })
      } catch (error) {
        console.error('❌ Error al cargar roles:', error)
        console.error('📊 Detalles del error:', {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL
        })
        
        // Si es un error de red, verificar si el backend está funcionando
        if (error.code === 'ECONNREFUSED' || error.message.includes('Network Error')) {
          this.error = 'No se puede conectar al backend. Verifica que el servidor esté funcionando en el puerto 8080.'
        } else {
          this.error = error.response?.data?.message || error.message || 'Error desconocido al cargar los roles'
        }
        
        this.$toast({
          component: { template: '<div>Error al cargar los roles</div>' },
          props: { variant: 'danger' },
        })
      } finally {
        this.loading = false
      }
    },
    
    editarRol(id) {
      this.$toast({
        component: { template: '<div>Funcionalidad en desarrollo</div>' },
        props: { variant: 'info' },
      })
    },
    
    eliminarRol(id) {
      this.$swal({
        title: '¿Estás seguro?',
        text: 'Este rol será eliminado permanentemente',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.value) {
          const index = this.roles.findIndex(r => r.idRol === id)
          if (index > -1) {
            this.roles.splice(index, 1)
            this.$toast({
              component: { template: '<div>Rol eliminado correctamente</div>' },
              props: { variant: 'success' },
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.usuarios-roles {
  padding: 1.5rem;
}

.content-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}
</style>
